import { defineStore } from "pinia";
import { toast } from "@/utils/toast";
import loanTypesService from "@/services/hrm/loan-types.service";

const errMsg = (e) =>
  e?.response?.data?.message || e?.message || "Unexpected error";

export const useLoanTypesStore = defineStore("loanTypes", {
  state: () => ({
    rows: [],
    loading: false,
  }),

  actions: {
    async fetch(params = {}) {
      this.loading = true;
      try {
        const { data } = await loanTypesService.list(params);
        this.rows = Array.isArray(data) ? data : (data?.data || []);
      } catch (e) {
        toast(errMsg(e), "error");
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async create(payload) {
      const { data } = await loanTypesService.create(payload);
      toast("Loan type created");
      return data;
    },

    async update(id, payload) {
      const { data } = await loanTypesService.update(id, payload);
      toast("Loan type updated");
      return data;
    },

    async destroy(id) {
      await loanTypesService.destroy(id);
      toast("Loan type deleted");
    },
  },
});
